import { render, staticRenderFns } from "./PRJ910P05.vue?vue&type=template&id=4bee60b0&"
import script from "./PRJ910P05.vue?vue&type=script&lang=js&"
export * from "./PRJ910P05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports